import React, { Component } from 'react';
import { connect } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import { selectDetailsMemberDownloadDate } from '../../../selectors/detailsSelectors';

import './MemberDetailsDownloadInfo.less';

interface Props {
  needsToUpgrade: boolean;
  contentTypesString: string;
  memberDownloadDate: string;
  isVideoDetailsPage?: boolean;
  className?: string;
}

class MemberDetailsDownloadInfo extends Component<Props> {
  render() {
    return this.needsUpgradeToAccessContent()
      ? this.unlimitedUpgradeMessaging()
      : this.renderPriorDownloadDate();
  }

  needsUpgradeToAccessContent() {
    return this.props.needsToUpgrade;
  }

  unlimitedUpgradeMessaging() {
    const { isVideoDetailsPage } = this.props;
    const {
      contentTypesString = 'HD footage, 4k clips, and templates',
      className = '',
    } = this.props;

    if (isVideoDetailsPage) {
      return (
        <div className="bg-gray-800 border-gray-600 rounded-xl text-sm text-center p-4 mt-4 xl:mt-1 mb-0 xl:mb-5 mx-3">
          <div className="memberDetailsDownloadInfo mt-0 text-white">
            <a href="/upgrade-my-plan" className="text-white underline">
              Upgrade
            </a>{' '}
            for unlimited downloads of {contentTypesString}.
          </div>
        </div>
      );
    }

    return (
      <div className={twMerge('memberDetailsDownloadInfo', className)}>
        Upgrade to Unlimited for unlimited downloads of {contentTypesString}{' '}
        from the Member Library.
      </div>
    );
  }

  renderPriorDownloadDate() {
    const { memberDownloadDate, className = '' } = this.props;
    if (memberDownloadDate) {
      return (
        <div className={twMerge('memberDetailsDownloadInfo', className)}>
          You downloaded this item on {memberDownloadDate}
        </div>
      );
    } else {
      return null;
    }
  }
}

export function mapStateToProps(state) {
  return {
    memberDownloadDate: selectDetailsMemberDownloadDate(state),
  };
}

export default connect(mapStateToProps)(MemberDetailsDownloadInfo);
